import { render, staticRenderFns } from "./row-shading.vue?vue&type=template&id=8c8122c0&"
import script from "./row-shading.vue?vue&type=script&lang=js&"
export * from "./row-shading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports